export { default } from './MeetingCommunicationMessageContent';
